import React from 'react';
import PropTypes from 'prop-types';
import ViewSelector from 'components/ViewSelector/ViewSelector';
import Cinema from 'components/Filters/Cinema';
import './cinema-filter.scss';


const CinemaFilter = ({ selectedCinema, selectCinema, selectView, selectedView, cinemas, isRequested }) => {
  const cinemaReplacer = (name) => {
    let result = name;
    if (name.includes('artmozi')) {
      result = name.replace('artmozi', '');
    } else if (name.includes('Távmozi')) {
      result = name;
    } else if (name.includes('mozi')) {
      result = name.replace('mozi', '');
    } else if (name.includes('Mozi')) {
      result = name.replace('Mozi', '');
    }
    return result;
  };

  if (cinemas === null || cinemas.length < 2) {
    return null;
  }

  return (
    <div className="react-cinema-filter-container">
      <div className="react-cinema-filter-visibility-container">
        <div className="react-filter-title">Válassz mozit!</div>
        <ViewSelector selectView={(view) => { selectView(view); }} selectedView={selectedView} />
      </div>
      <div className="react-cinema-filter-boxes-container">
        <Cinema title="Összes" selectedCinema={selectedCinema} onClick={() => { selectCinema(0); }} id={0} />
        {cinemas && cinemas.map(cinema => (
          <Cinema
            key={cinema.id.toString()}
            id={cinema.id}
            title={cinemaReplacer(cinema.name)}
            logo={cinema.logo}
            selectedCinema={selectedCinema}
            isRequested={isRequested}
            onClick={() => {
              if (!isRequested) {
                selectCinema(cinema.id);
              }
            }}
          />
        ))}
      </div>
    </div>
  );
};

CinemaFilter.propTypes = {
  selectedCinema: PropTypes.number.isRequired,
  selectCinema: PropTypes.func.isRequired,
  selectView: PropTypes.func.isRequired,
  selectedView: PropTypes.string.isRequired,
  cinemas: PropTypes.arrayOf(PropTypes.shape({})),
  isRequested: PropTypes.bool,
};

CinemaFilter.defaultProps = {
  isRequested: false,
  cinemas: null,
};

export default CinemaFilter;
